
const fix = '/qml'

export default{

  qml:{
    getCode:fix+"/sys/getCode",//获取图形验证吗
    sendCode:fix+"/send_code",//发送短信验证码
    sendCodeEx:fix+"/send_code_ex",//发送短信验证码
    login:fix+"/loginH5",//用户登入接口
    setPass:fix+"/setPasswordCode",//设置用户密码
    checkPass:fix+"/checkPass",//设置用户密码
    getuserInfo:fix+"/getuserInfo",//获取到用户信息
    getPopData:fix+"/getPopData",//推广加密数据
    exitUser:fix+"/loginOut",//退出
    createOrder:fix+"/createOrder",
    wxgetShareConfig: fix+"/wx/getShareConfig",
    getSocketToken: fix+"/getSocketToken",
    getdwz: fix+"/getdwz",
    queryOrderApp: fix+"/queryOrderApp",
    init: fix+"/sys/init",
    getIosUrl: fix+"/getIosUrl",
    getUserFriend: fix+"/v2/getFriend",
    addOneByOne:fix+"/v2/onebyone",
    getAppSatus:fix+"/v2/get/appStatus"



  }

}


// WEBPACK FOOTER //
// ./src/api/index.js